import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { WifiOffIcon, WifiIcon } from 'lucide-react';
import { useOnlineStatus } from '../../app/hooks/useOnlineStatus';
/**
 * F5.6 Offline Indicator
 *
 * - Toont een amber banner zolang de gebruiker offline is.
 * - Toont kort (3s) een groene "weer online" bevestiging na herstel.
 * - Niet-blokkerend: alle practice-functies blijven client-side werken.
 * - Respecteert safe-area-inset-top voor iPhones met notch.
 */
export function ConnectionStatus() {
  const {
    isOnline,
    wasOffline
  } = useOnlineStatus();
  const showOffline = !isOnline;
  const showReconnected = isOnline && wasOffline;
  return <AnimatePresence data-id="element-2146">
      {showOffline && <motion.div key="offline" role="status" aria-live="polite" initial={{
      y: -40,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -40,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed top-0 inset-x-0 z-[60] pt-safe" data-id="element-2147">
          <div className="mx-auto max-w-2xl m-2 px-4 py-2.5 rounded-xl bg-amber-100 border border-amber-300 text-amber-900 shadow-md flex items-center gap-3" data-id="element-2148">
            <WifiOffIcon className="w-4 h-4 flex-shrink-0" aria-hidden="true" data-id="element-2149" />
            <p className="text-xs sm:text-sm font-semibold leading-tight" data-id="element-2150">
              Je bent offline — je voortgang wordt opgeslagen zodra je weer
              verbinding hebt.
            </p>
          </div>
        </motion.div>}

      {showReconnected && <motion.div key="reconnected" role="status" aria-live="polite" initial={{
      y: -40,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -40,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed top-0 inset-x-0 z-[60] pt-safe" data-id="element-2151">
          <div className="mx-auto max-w-2xl m-2 px-4 py-2.5 rounded-xl bg-emerald-100 border border-emerald-300 text-emerald-900 shadow-md flex items-center gap-3" data-id="element-2152">
            <WifiIcon className="w-4 h-4 flex-shrink-0" aria-hidden="true" data-id="element-2153" />
            <p className="text-xs sm:text-sm font-semibold leading-tight" data-id="element-2154">
              Je bent weer online!
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}